import type { ReactNode } from 'react';

import {
  type IconVariantProps,
  icon as iconRecipe,
} from '@mage-ui/styled-system/recipes';

export type IconRawProps = {
  name: string;
  classNames?: { svg: string };
} & IconVariantProps;

export const IconRaw = ({ name, classNames }: IconRawProps): ReactNode => {
  const classes = iconRecipe();
  return (
    <svg className={classNames?.svg ?? classes.svg}>
      <title>{name}</title>
      <use href={`/icons/sprite.svg#${name}`} />
    </svg>
  );
};
